import { HttpErrorResponse } from '@angular/common/http';

/* tslint:disable:no-empty-interface */
export interface ExistingUserRegistrationFormPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  city: string;
  province: string;
  country: string;
  zipCode: string;
  employer?: string;
  termsAndConditions: boolean;
}

export interface ExistingUserRegistrationFormSubmit extends ExistingUserRegistrationFormPayload { }
export interface ExistingUserRegistrationFormResponse {
  message: string;
  cognito_username?: string;
  cognito_email?: string;
  parameters: any;
  'amilearn-id': number;
  'amilearn-status': string;
}

export class APIHTTPErrorResponse extends HttpErrorResponse {
  // readonly error: APIError;
  constructor(initError: HttpErrorResponse) {
    super({ ...initError, error: initError.error as APIError });
  }
}

export interface APIError {
  message: string;
  errorCode: string;
}

export interface ProtectedTestAPIResponse { }
export interface OAuthToken {
  id_token: string;
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string | 'Bearer';
}

export interface OAuthRevokeResponse {
  error?: string;
  error_description? : string;
}